import { GraphQLClient } from 'graphql-request'
import Mutations from './graphql/mutations'

class API {
  request(...args) {
    return new GraphQLClient('/api/graphql').request(...args)
  }

  createLead(data) {
    return this.request(Mutations.LeadCreate, { data }).then(data => data.LeadCreate)
  }
}

export default new API()
